<template>
    <div class="columns">
        <div class="column">
            <div class="content">
                <h2 class="title">arcdps Log Manager</h2>
                <p>
                    A manager for all your recorded logs. Filter logs, upload them with one click, find
                    interesting statistics.
                </p>
                <strong>Have you...</strong>
                <ul>
                    <li>ever wanted to see which Strikes you have done this week already?</li>
                    <li>ever wanted to upload all kills in your latest fullclear to <a href="https://dps.report">dps.report</a> with one click?</li>
                    <li>ever wondered what your fastest Mursaat Overseer kill was?</li>
                    <li>ever wanted to know how many times you had a Core Necromancer in a successful run?</li>
                    <li>ever wanted to find out who is the one you raid with the most?</li>
                    <li>ever wanted to find out how many hours you have spent in Dhuum failures?</li>
                </ul>
                <strong>You can...</strong>
                <ul>
                    <li>filter logs by time, encounter, success/failure, CM/non-CM.</li>
                    <li>quickly see the composition, players, encounter duration for all your logs.</li>
                    <li>upload to <a href="https://dps.report/">dps.report</a> with one click, do batch uploads.</li>
                    <li>see a table of all players in your currently filtered logs.</li>
                    <li>see a table of all guilds in your currently filtered logs.</li>
                    <li>check your weekly clears.</li>
                    <li>work with thousands of logs.</li>
                </ul>
                <h3>Bugs and feature requests</h3>
                <p>
                  If you run into any issues or have some ideas for new features, feel free to let us know on
                  our <router-link to="/discord">discord server</router-link> or you can use <a href="https://github.com/gw2scratch/evtc/issues">GitHub issues</a>.
                </p>
                <p>
                  You can find already reported issues and requested features
                  <a href="https://github.com/orgs/gw2scratch/projects/1">here</a>.
                </p>
            </div>
        </div>
        <div class="column is-4">
            <ProgramDownloads release-feed-url="/releases/manager.json" program-name="arcdps Log Manager" />
            <ProgramImage :src="logManagerImage" alt="Log list in the arcdps Log Manager" />
            <ProgramImage :src="logManagerClearsImage" alt="Weekly clears in the arcdps Log Manager" />
        </div>
    </div>
</template>

<script>
    import logManagerImage from "@/assets/images/log-manager.png";
    import logManagerClearsImage from "@/assets/images/log-manager-clears.png";
    import ProgramDownloads from "@/components/ProgramDownloads";
    import ProgramImage from "@/components/ProgramImage";

    export default {
        name: 'tools-manager',
        components: {ProgramDownloads, ProgramImage},
        data() {
            return {
                logManagerImage,
                logManagerClearsImage,
            }
        }

    }
</script>

<style>
</style>
